<div class="entity">
  <div *ngFor="let entity of entities" class="mt-4 mb-4 text-center">
    <div [routerLink]="[entity.route]" routerLinkActive="active" style="cursor: pointer;" *ngIf="entity.toShow">
      <a class="entity-link">
        <i class="bi entity-icon" [ngClass]="entity.icon"></i>
      </a>
      <p class="mt-2 entity-name">{{entity.name}}</p>
    </div>
  </div>
</div>
